import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { BaseCellProps, CellType } from "@components/spreadsheet/cells";
import { ColumnDef } from "@components/spreadsheet/types";
import { TransactionSplitLedgerCell } from "./TransactionSplitLedgerCell";

const LEDGER_COLUMNS = {
    [AccountingLedgerBasis.cash]: { field: "accountId", label: "Cash ledger" },
    [AccountingLedgerBasis.accruals]: {
        field: "accrualAccountId",
        label: "Accrual ledger",
    },
} satisfies Record<AccountingLedgerBasis, { field: string; label: string }>;

interface CreateLedgerColumnParams {
    ledgerBasis: AccountingLedgerBasis;
    getEntityId: (row: BaseCellProps["row"]) => number | undefined;
    canClear?: boolean;
    isEditable?: boolean;
}

export const createLedgerColumn = ({
    ledgerBasis,
    getEntityId,
    canClear = false,
    isEditable = true,
}: CreateLedgerColumnParams): ColumnDef => ({
    ...LEDGER_COLUMNS[ledgerBasis],
    cellType: CellType.LEDGER,
    isEditable,
    cellFn: (props) => (
        <TransactionSplitLedgerCell
            {...props}
            value={typeof props.value === "string" ? props.value : null}
            entityId={getEntityId(props.row)}
            ledgerBasis={ledgerBasis}
            canClear={canClear}
        />
    ),
});
